const csCZ= {
    login: {
      title: 'Přihlásit se',
      sign_in_btn: 'Přihlásit se'
    },
    bar: {
        logout: 'Odhlásit se',
        languages: 'Jazyky',
        settings: 'Otevřít nastavení'
    },
    language: {
      name: 'Česky (Česká republika)',
    },
    attributePage: {
        title: 'Změny atributů',
        viewChanges: 'Viz změny',
        dateTime: 'Datum',
        notificationType: 'Typ oznámení',
        notificationValue: 'Hodnota oznámení',
        oldValue: 'Původní hodnota',
        newValue: 'Nová hodnota',
        accept: 'Přijmout',
        reject: 'Odmítnout',
    },
    Home: 'Domů',
    load: 'Probíhá počáteční načítání...',
    Requested: "Vyžádáno",
    Viewed: "Zobrazeno",
    Executing: "Provádím",
    Completed: "Dokončeno",
    Expired: "Vypršelo",
    Cancelled: "Zrušeno",
    Error: "Chyba",
    Rejected: "Zamítnuto",
    error: 'Něco se pokazilo. Zkuste to prosím znovu později.',
    displayname: 'Zobrazené jméno',
    givenname: 'Jméno',
    surname: 'Příjmení',
    email: 'E-mail',
    mail: 'E-mail',
    name: 'Jméno',
    firstname: 'Jméno',
    lastname: 'Příjmení',
    footer_copyright: 'Všechna práva vyhrazena.'
  };
  
  export default csCZ;
  